<template>
  <v-card>
    <v-card-text :style="{ borderTop: color ? `7px solid ${color}` : '' }">
      <p class="mb-1">
        {{ title }}
      </p>
      <h1 class="text-truncate text-h6 font-weight-bold">
        {{ content || '-' }}
      </h1>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    },
    content: {
      type: [String, Number],
      required: false,
      default: undefined
    },
    color: {
      type: String,
      required: false,
      default: null
    }
  },
}
</script>